import 'css-chunksrc/client/scenes/event/styles.scss';export default {
  "event": "_event_10g54_1",
  "eventLoading": "_eventLoading_10g54_10",
  "loader": "_loader_10g54_16",
  "loaderMain": "_loaderMain_10g54_30",
  "main": "_main_10g54_37",
  "content": "_content_10g54_43",
  "secondaryCriteria": "_secondaryCriteria_10g54_49",
  "label": "_label_10g54_54",
  "row": "_row_10g54_60",
  "configurationIconBox": "_configurationIconBox_10g54_71",
  "configurationIcon": "_configurationIcon_10g54_71",
  "scrollWrapper": "_scrollWrapper_10g54_89",
  "timeline": "_timeline_10g54_98",
  "timestamp": "_timestamp_10g54_105",
  "comments": "_comments_10g54_116",
  "header": "_header_10g54_124",
  "contentHeader": "_contentHeader_10g54_137",
  "title": "_title_10g54_146",
  "rightContent": "_rightContent_10g54_154",
  "rightContentMultiProject": "_rightContentMultiProject_10g54_160",
  "contentProjectRedirection": "_contentProjectRedirection_10g54_164",
  "contentModal": "_contentModal_10g54_168",
  "list": "_list_10g54_173",
  "folderIcon": "_folderIcon_10g54_180",
  "icon": "_icon_10g54_184",
  "scenePlaceholder": "_scenePlaceholder_10g54_190"
};